export enum EErrorReason {
  engine = 'ENGINE',
  mqtt = 'MQTT',
  camera = 'CAMERA',
  performance = 'PERFORMANCE',
  unknown = 'UNKNOWN'
}
